import { envConfig } from "@/libs/env-config";
import { getCommonHeaders } from "./common";

interface InventoryResponse {
  responseCode: number;
  responseMessage: string;
  hasMore: boolean;
  response: {
    skuCode: string;
    qty: number;
    committedQty?: number;
  }[];
}

export const checkInventory = async (
  skuCodes: string[]
): Promise<InventoryResponse> => {
  try {
    const url = new URL(`${envConfig.apiInventoryUrl}/storefront/inventory`);

    const options: RequestInit = {
      method: "POST",
      headers: getCommonHeaders(),
      body: JSON.stringify({
        sku_codes: skuCodes,
        page_number: "",
      }),
    };

    const response = await fetch(url.toString(), options);
    if (!response.ok) {
      console.error("Failed to fetch inventory. Status:", response.status);
      return {
        responseCode: 0,
        responseMessage: "Error",
        hasMore: false,
        response: [],
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error checking inventory:", error);
    return {
      responseCode: 0,
      responseMessage: "Error",
      hasMore: false,
      response: [],
    };
  }
};